var _g, _rect, _rect2, _rect3, _rect4, _g2, _g3, _rect5, _rect6, _rect7, _rect8, _rect9, _g4, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicCustomizationFeature01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 169,
    viewBox: "0 0 275 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2033_20908)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.3906,
    width: 201.553,
    height: 149.71,
    rx: 4,
    fill: "url(#paint0_linear_2033_20908)",
    fillOpacity: 0.4
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 92.9961,
    y: 5.82031,
    width: 43.3788,
    height: 8.46416,
    rx: 4.23208,
    fill: "#EAEAEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 138.492,
    y: 5.82031,
    width: 44.9659,
    height: 8.46416,
    rx: 4.23208,
    fill: "#EAEAEA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 185.574,
    y: 5.82031,
    width: 33.3276,
    height: 8.46416,
    rx: 4.23208,
    fill: "#EAEAEA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 221.016,
    y: 5.82031,
    width: 8.46416,
    height: 8.46416,
    rx: 4.23208,
    fill: "#EAEAEA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2033_20908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232 17.2353H94.536C92.3269 17.2353 90.536 15.4444 90.536 13.2353V11.1471V8C90.536 5.79086 88.7451 4 86.536 4H46.752C44.5429 4 42.752 5.79086 42.752 8V11.1471V14.0673C42.752 15.8169 41.3336 17.2353 39.584 17.2353C38.7092 17.2353 38 17.9445 38 18.8193V143.741C38 145.948 39.7876 147.738 41.9947 147.741L231.995 147.995C234.206 147.998 236 146.206 236 143.995V21.2353C236 19.0262 234.209 17.2353 232 17.2353Z",
    fill: "url(#paint1_linear_2033_20908)",
    fillOpacity: 0.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2033_20908)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.0039,
    y: 145.325,
    width: 252.992,
    height: 10.0773,
    rx: 4.24306,
    fill: "#111111"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44.8555,
    y: 5.82031,
    width: 43.3788,
    height: 8.46416,
    rx: 4.23208,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 213.082,
    y: 8.46484,
    width: 3.17406,
    height: 3.17406,
    rx: 1.58703,
    fill: "#D8D8D8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 177.637,
    y: 8.46484,
    width: 3.17406,
    height: 3.17406,
    rx: 1.58703,
    fill: "#D8D8D8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 130.027,
    y: 8.46484,
    width: 3.17406,
    height: 3.17406,
    rx: 1.58703,
    fill: "#D8D8D8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 82.418,
    y: 8.46484,
    width: 3.17406,
    height: 3.17406,
    rx: 1.58703,
    fill: "#EAEAEA"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2033_20908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 47C85 42.5817 88.5817 39 93 39H182C186.418 39 190 42.5817 190 47V109C190 113.418 186.418 117 182 117H93C88.5817 117 85 113.418 85 109V47Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.542 56.875H121.458C118.927 56.875 116.875 58.927 116.875 61.4583V93.5417C116.875 96.073 118.927 98.125 121.458 98.125H153.542C156.073 98.125 158.125 96.073 158.125 93.5417V61.4583C158.125 58.927 156.073 56.875 153.542 56.875Z",
    stroke: "#111111",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.48 72.9167C131.379 72.9167 132.918 71.3777 132.918 69.4792C132.918 67.5807 131.379 66.0417 129.48 66.0417C127.582 66.0417 126.043 67.5807 126.043 69.4792C126.043 71.3777 127.582 72.9167 129.48 72.9167Z",
    stroke: "#111111",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.124 84.375L146.665 72.9167L121.457 98.125",
    stroke: "#111111",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2033_20908",
    x: 34.2691,
    y: -2.12153,
    width: 205.798,
    height: 153.953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.06076
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2033_20908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2033_20908",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2033_20908",
    x: 35.8785,
    y: 1.87847,
    width: 202.243,
    height: 148.238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.06076
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2033_20908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2033_20908",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2033_20908",
    x: 0.396267,
    y: 136.838,
    width: 274.207,
    height: 31.2925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.12153
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.30382
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2033_20908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2033_20908",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2033_20908",
    x: 65,
    y: 23,
    width: 145,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2033_20908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2033_20908",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2033_20908",
    x1: 137.167,
    y1: 0,
    x2: 137.167,
    y2: 149.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2033_20908",
    x1: 137,
    y1: 4,
    x2: 137,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicCustomizationFeature01);
export default __webpack_public_path__ + "static/media/sonic-customization-feature-01.e40d3fd10da2e6a5da88919b186e4df3.svg";
export { ForwardRef as ReactComponent };